import * as React from 'react';
import { Label } from '@cian/ui-kit';
import { IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export const DiscountMortgageLabel = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div className={styles['label']} {...props} ref={ref}>
      <Label
        background="decorative-purple"
        color="theme-white"
        icon={<IconProductHighDemand16 color="icon-inverted-default" />}
      >
        Льготная ипотека
      </Label>
    </div>
  );
});

DiscountMortgageLabel.displayName = 'DiscountMortgageLabel';
